// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1nYIf","detailsBorder":"styles_detailsBorder__2t5DS"};